import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { CourseService } from '../../services/course.service';
import { JobService } from '../../services/jobs/job.service';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { ActivatedRoute, Router } from '@angular/router'
import { MatSnackBar } from '@angular/material/snack-bar';
import { UtilityService } from '../../services/utility.service'


@Component({
  selector: 'app-quiz-list',
  templateUrl: './quiz-list.component.html',
  styleUrls: ['./quiz-list.component.scss']
})
export class QuizListComponent implements OnInit {

  @Input('courseId') course
  @Input('singleJob') jobData
  @Input('assignmentList') assignment
  movementCount;
  selectedCourse;
  quizList = [];
  sequence_alert; 
  courseQuiz
  singleJobDetails
  assignmentDetails
  quizStatus
  isDisable = false
  tooltip
  jobIdCurrent
  learnerIdCurrent

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    private _snackBar: MatSnackBar,
    public _courseService: CourseService,
    public jobService: JobService,
    public _utilityService: UtilityService
  ) {
     }

  ngOnInit() {
  }



  ngOnChanges(changes: SimpleChanges): void {
    console.log("changes: SimpleChanges", changes)
    if (changes.course && changes.course.currentValue) {
      this.selectedCourse = changes.course.currentValue
      // console.log("find the current course id",this.selectedCourse);
      this.getsquenceOflistCourse()
      // this.getQuizListOfCourse()
    }
    if (changes.jobData && changes.jobData.currentValue) {
      console.log("what is the value of single job in quiz list page", changes.jobData.currentValue);
      this.singleJobDetails = changes.jobData.currentValue
      this.selectedCourse = changes.jobData.currentValue.course._id
      if (this.singleJobDetails.jobMeta.sequence.length) {
        this.quizList = this.singleJobDetails.jobMeta.sequence
      } else {
        this.getQuizListOfCourse()
      }

    }
    if (changes.assignment && changes.assignment.currentValue) {
      this.assignmentDetails = changes.assignment.currentValue
      this.quizList = this.assignmentDetails.quiz
      this.quizStatus = this.assignmentDetails.quizStatus
      this.jobIdCurrent = this.assignmentDetails.job
      this.learnerIdCurrent = this.assignmentDetails.learner
      this.isDisable = true
    }


  }



  // UTILITY


  getRandomColorClass(index) {
    return this._utilityService.getCommonRandomColorClass(index)
  }

  drop(event) {
    console.log("event", event);
    // array drag item seuqence update 
    moveItemInArray(this.quizList, event.previousIndex, event.currentIndex);

    console.log("data update item list", this.quizList);

  }


  getStatus(quiz) {


    let item = this.quizStatus.find(x => x.quizId === quiz._id);
    // console.log("what is item", item);
    if (item && item.assessmentList && item.assessmentList.length) {
      let lastAssesment = item.assessmentList.slice(-1)[0]
      if (lastAssesment != undefined) {
        if (lastAssesment.status) {
          // console.log("what is item with status", lastAssesment);
          switch (lastAssesment.status) {
            case 'Submitted':
              this.tooltip = 'Submitted';
              return 'submitted'
              break;

            case 'Completed':
              // console.log("this field is call ");

              this.tooltip = 'Completed';
              return 'completed'
              break;

            case 'Requested for Resubmission':
              this.tooltip = 'Requested for Resubmission';
              return 'requested'
              break;

            case 'Re-Submitted':
              this.tooltip = 'Re-Submitted';
              return 'resubmitted'
              break;

            case 'Saved':
              this.tooltip = 'Saved';
              return 'saved'
              break;

            default:
              // console.log("default called");

              this.tooltip = 'Pending';
              return 'pending'
              break;
          }
        } else {
          console.log("this is else part");

          this.tooltip = 'Pending';
          return 'pending'

        }
        // return lastAssesment.status
      }
    } else {
      this.tooltip = 'Pending';
    }

  }

  // API CALL



  getQuizListOfCourse() {

    this._courseService.getQuizList(this.selectedCourse).subscribe((response) => {
      console.log("response of all which only quiz", response);
      if (response && response.length) {
        this.courseQuiz = response[0]
        this.quizList = this.courseQuiz.quizList
      }
    }, error => {
      console.log("error while manage sequence", error);

    })

  }

  //whene update sequence then get sequence list call Api course service

  getsquenceOflistCourse() {
    this._courseService.SquencegetCourseList(this.selectedCourse).subscribe((response) => {

      console.log("response of all quiz to manage sequence", response);
      let sequencelength = response[0].sequence;
      // check sequence list of length null or not 

      if (Array.isArray(sequencelength) && sequencelength.length) {
        this.courseQuiz = response[0]
        this.quizList = this.courseQuiz.sequence

      } else {

        //  whene seuence null then call old sequence 
        this.getQuizListOfCourse();
        // this.sequence_alert=false;

      }
    }, error => {
      console.log("error while manage sequence", error);

    })
  }

  //  add sequnce success alert 
  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 5000,
    });
  }


  setSequence() {

    console.log("check the job list", this.quizList);

    this.quizList.forEach((obj, i) => obj.index = i);
    console.log("data store with index", this.quizList);


    if (this.singleJobDetails) {
      console.log("single job value", this.singleJobDetails);
      let obj = {
        jobId: this.singleJobDetails._id,
        sequence: this.quizList
      }

      //Sequence Update API Call in jobservices

      this.jobService.updateSequence(obj).subscribe((res) => {
        console.log("sequence of job updated", res);
        this.handleSnackBar({ msg: "Sequence Update Successfully !", button: "Ok" });

      }, error => {
        console.log("error while update sequqence", error);

      })
    } else {
      console.log("this is for course");
      let obj = {
        courseId: this.selectedCourse,
        sequence: this.quizList
      }

      // Sequence Update API call in CourseService 
      this._courseService.updateSequence(obj).subscribe((response) => {
        this.handleSnackBar({ msg: "Sequence Update Successfully !", button: "Ok" });
        console.log("sequence update done", response);


      }, error => {
        console.log("error while update sequence", error);

      })
    }
  }


  appearQuiz(quiz) {
    if (this.isDisable == false) {
      console.log("this is for sequence");

    } else {

      let learnerId = this.route.snapshot.paramMap.get('id');
      console.log(this.singleJobDetails)

      console.log("check id console Learner" + this.learnerIdCurrent + "Job Id current" + this.jobIdCurrent)

      this.router.navigate(['/appear-quiz'], { queryParams: { quizId: quiz._id, learnerId: this.learnerIdCurrent, jobId: this.jobIdCurrent } })

      console.log("Learner Id Using:", learnerId);
      console.log("this is for redirect to the appear quiz", quiz);

    }
  }

}
